module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.15128/js/hsocImages/agent_hub_logo.svg"